<div class="main-container">

    <div class="header-container">
        <div class="header-text-container">
            <div><p class="history-heading-map-data-farm text-no-margin">Maps</p></div>
            <div><h2 class="splitter-map-data-farm text-no-margin"> | </h2></div>
            <div><p class="farm-heading-map-data-farm text-no-margin"> {{farmNameHeader}} </p></div>
        </div>

        <div class="close-icon-container">
            <div class="close-container"> <img src="../../../assets/icons/close.svg" alt="Icon description"
                 class="close-icon" (click)="onCloseClick()">
            </div>
        </div>

    </div>

    <mat-divider></mat-divider>

    <div class="secondary-container">

        <div class="side-nav-container">
            <div class="nav" [formGroup]="selectionState">

                <div class="nav-items">
                    <mat-list style="padding:0!important">
                        <mat-list-item
                            *ngFor="let analysisType of analysisTypes | orderBy: 'name'"
                            [disabled]="(!analysisType.available && !isRequestable(analysisType?.type)) || (analysisType?.alias === 'PROFITABILITY' && !viewProfitability)"
                            class="item"
                            [matTooltip]="hoverHelp(analysisType?.type)"
                            matTooltipPosition="right"
                            (click)="selectAnalysisType(analysisType)"
                            formControlName="prevSelect"
                            ngDefaultControl
                            [ngClass]="{'selected-item': analysisType.selected === true}">
                            <a #navAnalysisItem > {{analysisType.alias}}</a>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>

        <div class="period-item-list-container">
            <div class="period-btn-container" *ngIf="!disablePeriodRange">
                <div class="period-btn-container-farm">

                        <mat-button-toggle-group  #periodGroup="matButtonToggleGroup"  class="toggle-group-container-farm" [value]="selectedPeriod" (change)="clickPeriod(periodGroup.value)">
                            <div class="period-btn-container-farm" *ngIf="!disablePeriodRange">
                                    <mat-button-toggle   class="period-range-btn-farm selected-button-farm" type="button"
                                             id="PeriodThirtyDays" (click)="clickPeriod('30 days')"
                                             [disabled]="disablePeriodRange" [value]="'30 days'">30 Days </mat-button-toggle>

                                    <mat-button-toggle class="period-range-btn-farm selected-button-farm" type="button"
                                            id="PeriodThreeMonths" (click)="clickPeriod('3 months')"
                                            [disabled]="disablePeriodRange" [value]="'3 months'">3 Months</mat-button-toggle>

                                    <mat-button-toggle class="period-range-btn-farm selected-button-farm"  type="button" id="PeriodSixMonths"
                                            (click)="clickPeriod('6 months')"
                                            [disabled]="disablePeriodRange" [value]="'6 months'">6 Months</mat-button-toggle>

                                    <mat-button-toggle class="period-range-btn-farm selected-button-farm"  type="button" id="PeriodAll"
                                            (click)="clickPeriod('all')"
                                            [disabled]="disablePeriodRange" [value]="'all'">All</mat-button-toggle>

                                    <!-- Imagery Request Button -->
                                    <div *ngIf="showImageryRequestButton" class="imagery-request-container">
                                        <button mat-stroked-button class="flex items-center gap-1 h-11 px-3 rounded border border-[var(--primary-dark)] text-[var(--primary-dark)] bg-[var(--background)] font-medium text-[13px] hover:bg-[var(--base-light-variant)] disabled:opacity-60 disabled:cursor-not-allowed" [matMenuTriggerFor]="imageryRequestMenu" [disabled]="isRequestingImagery">
                                            <mat-icon>satellite_alt</mat-icon>
                                            <span>Request</span>
                                            <mat-icon>expand_more</mat-icon>
                                        </button>
                                        <mat-menu #imageryRequestMenu="matMenu" class="imagery-request-menu-compact" [hasBackdrop]="false">
                                            <div class="bg-[var(--primary-dark)] text-white px-4 py-2.5 font-semibold text-[13px]" (click)="$event.stopPropagation()">{{ imageryRequestTitle }}</div>
                                            
                                            <div class="p-4 space-y-3 min-w-[280px]" (click)="$event.stopPropagation()">
                                                <!-- Farm info -->
                                                <div class="flex items-center gap-2 text-[13px] text-[var(--base-text-alt-dark)] bg-[var(--app-base)] rounded-lg px-3 py-2.5">
                                                    <span class="material-icons text-[18px] text-gray-400">agriculture</span>
                                                    <span class="font-medium">All fields on {{farmNameHeader}}</span>
                                                </div>
                                                
                                                <!-- Date Range Dropdown -->
                                                <div>
                                                    <label class="block text-[11px] font-bold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Date Range</label>
                                                    <div class="relative" #dateDropdown>
                                                        <div (click)="showDateMenu = !showDateMenu; $event.stopPropagation()"
                                                            class="w-full py-2 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)] transition-colors">
                                                            <span>{{getDateOptionLabel()}}</span>
                                                            <span class="material-icons text-[18px] text-gray-400">expand_more</span>
                                                        </div>
                                                        <div *ngIf="showDateMenu" class="absolute top-[calc(100%+4px)] left-0 right-0 bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.15)] py-1 z-[9999]">
                                                            <div (click)="imageryRequestDateOption='30days'; showDateMenu=false" 
                                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                                [class.font-semibold]="imageryRequestDateOption === '30days'">Last 30 Days</div>
                                                            <div (click)="imageryRequestDateOption='60days'; showDateMenu=false"
                                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                                [class.font-semibold]="imageryRequestDateOption === '60days'">Last 60 Days</div>
                                                            <div (click)="imageryRequestDateOption='90days'; showDateMenu=false"
                                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                                [class.font-semibold]="imageryRequestDateOption === '90days'">Last 90 Days</div>
                                                            <div (click)="imageryRequestDateOption='custom'; showDateMenu=false"
                                                                class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]"
                                                                [class.font-semibold]="imageryRequestDateOption === 'custom'">Custom Range...</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Custom Date Pickers -->
                                                <div *ngIf="imageryRequestDateOption === 'custom'" class="flex items-center gap-3" (click)="$event.stopPropagation()">
                                                    <ui-datepicker label="FROM" [value]="imageryRequestDateFromStr" (valueChange)="onDateFromChange($event)" [compact]="true" [centerScreen]="true"></ui-datepicker>
                                                    <ui-datepicker label="TO" [value]="imageryRequestDateToStr" (valueChange)="onDateToChange($event)" [compact]="true" [centerScreen]="true"></ui-datepicker>
                                                </div>

                                                <button (click)="submitImageryRequest()" [disabled]="isRequestingImagery"
                                                    class="w-full bg-[var(--primary-dark)] hover:opacity-90 disabled:opacity-50 text-white font-semibold text-[13px] py-2.5 px-4 rounded-lg flex items-center justify-center gap-2 transition-opacity">
                                                    <span class="material-icons text-[18px]" *ngIf="!isRequestingImagery">send</span>
                                                    <mat-spinner *ngIf="isRequestingImagery" diameter="16"></mat-spinner>
                                                    <span>{{isRequestingImagery ? 'Requesting...' : 'Request'}}</span>
                                                </button>
                                            </div>
                                        </mat-menu>
                                    </div>
                            </div>
                        </mat-button-toggle-group>
                </div>
            </div>

                <div class="Variance-options-container-farm" *ngIf="!disablePeriodRange">
                    <mat-button-toggle-group #varianceGroup="matButtonToggleGroup"  class="toggle-group-container-farm" [value]="selectedVariance" (change)="clickVariance(varianceGroup.value)">
                <div class="period-btn-container-farm">

                            <span class="Variance-heading-map-data-farm">Variance in days</span>

                                <mat-button-toggle  class="Variance-btn-farm"(click)="clickVariance(1)" [value]="1">1</mat-button-toggle>

                                <mat-button-toggle class="Variance-btn-farm" (click)="clickVariance(5)" [value]="5">5</mat-button-toggle>

                                <mat-button-toggle  class="Variance-btn-farm" (click)="clickVariance(10)" [value]="10">10</mat-button-toggle>

                                <div></div>

                                <mat-button-toggle class="Variance-btn-farm" (click)="clickVariance(20)" [value]="20">20</mat-button-toggle>


            </div>
                    </mat-button-toggle-group>
                </div>
            <div class="list-container-farm">
            <div class="map-data-list-container-farm">

                <!--List Item for non Chemical items-->
                <div *ngIf="showAnalysisList">
                    <div class="list-item-analysis-container-farm" *ngFor="let analysisTypeListItem of filteredList" (click)="overlayAnalysis(analysisTypeListItem.datePerformed,analysisTypeListItem.type,analysisTypeListItem.items[0])">
                        <div class="list-item-analysis-farm">
                            <div><p class="list-item-farm">

                                {{
                                     analysisTypeListItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase()) ?
                                     (formatDate(analysisTypeListItem.datePerformed, 'YYYY'))
                                     : analysisTypeListItem.datePerformed
                                }}

                                <span style="color:#9898a2; font-size: 11px; padding-left: 3px;"> | {{ analysisTypeListItem.coverage }}% Coverage</span></p></div>

                            <div><h4 class="list-item-spacer-farm">  </h4></div>
                            <div><p class="list-item-original-farm"></p></div>
                            <div class="view-eye-icon-container-farm"><img src="../../../assets/icons/view-eye.svg"
                                                                            alt="Icon description" class="view-eye-icon-farm"></div>
                        </div>
                    </div>
                    <div class="load-more-btn-container" 
                        *ngIf="this.filteredItemObj.type.toLowerCase().includes('SATELLITE'.toLowerCase()) && !this.filteredItemObj.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase()) && this.filteredItemObj.period != 'all' && showNoDataCard">
                        <div class="Load-More-btn-container-farm">
                            <button class="Load-More-btn-farm" mat-flat-button type="button" (click)="loadMore()">Load More</button>
                        </div>
                    </div>
                </div>


                <div *ngIf="showChemList">
                    <mat-expansion-panel class="chem-list-main-container" *ngFor="let analysisTypeListItem of filteredList">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="maps-chem-item-main-header-farm">
                                <div *ngIf="!analysisTypeListItem.type.toLowerCase().includes('satellite') && analysisTypeListItem.type.toLowerCase().includes('chemical') && helper.doesUserHaveRole('Analysis Reporting')" class="download-icon-farm tooltip" (click)="generateFarmAnalysis(formatDate(analysisTypeListItem.datePerformed, 'YYYY'), $event)">
                                    <img src="assets/icons/download.svg" alt="Download Icon" class="download-icon-farm" data-tooltip="Generate">
                                    <!-- <span class="tooltiptext">Generate Report</span> -->
                                </div>
                                {{formatDate(analysisTypeListItem.datePerformed, 'YYYY')}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="maps-chem-item-header">
                            <label class=""></label>
                            <div class="">
                                <div class="maps-chem-item-container-farm" *ngFor="let item of analysisTypeListItem.items">
                                    <label class=""></label><br/>
                                    <label class="item-chem-farm" (click)="overlayAnalysis(analysisTypeListItem.datePerformed, analysisTypeListItem.type, item)">{{item.propertyTypeName}}</label>
                                    <div class="item-chem-farm">
                                        <img src="assets/icons/view-eye.svg" alt="View Eye Icon " class="chem-view-eye-icon-farm">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                </div>

                <div *ngIf="!showNoDataCard" class="no-data-container-farm">
                    <h3>SORRY</h3>
                    <p>NO DATA AVAILABLE</p>
                    <p>Please select another analysis type,</p>
                    <p>period range, or use the load more button below.</p>
                </div>

            </div>
            </div>
          
    </div>
</div>



</div>
